export const fileUrl = (fileName: string) =>
  `https://gitlab.com/api/v4/projects/13371733/repository/files/${fileName}/raw?ref=master`;
